import { WifiPassword } from "@mui/icons-material";
import { Alert, CircularProgress } from "@mui/material";
import React, { useEffect, useState } from "react";
import { ButtonPill } from "../theme/StyledFields";
import {
  type AuthProcessName,
  requestNativeGoogleSignIn,
  subscribeNativeAuth,
} from "../utils/nativeAuthBridge";
import { AuthProcess } from "./lib/allauth";
import { ReactComponent as Google } from "./logos/google.svg";

interface GoogleInAppButtonProps {
  isConnected: boolean;
  process?: AuthProcessName;
}

const GoogleInAppButton: React.FC<GoogleInAppButtonProps> = ({
  isConnected = false,
  process = AuthProcess.LOGIN,
}) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    return subscribeNativeAuth((result) => {
      setLoading(false);
      if (result.status === "error") {
        if (result.code === "cancelled") {
          setError(null);
          return;
        }
        setError(result.message || "Google sign-in failed");
      } else {
        setError(null);
      }
    });
  }, []);

  const handleClick = async () => {
    setLoading(true);
    setError(null);
    try {
      await requestNativeGoogleSignIn(process);
    } catch (err) {
      setLoading(false);
      setError(err instanceof Error ? err.message : "Google sign-in failed");
    }
  };

  return (
    <React.Fragment>
      <ButtonPill
        onClick={() => void handleClick()}
        data-attr="google-in-app-button_sign-in"
        startIcon={loading ? <CircularProgress size={20} /> : <Google />}
        disabled={loading}
        endIcon={isConnected ? <WifiPassword /> : undefined}
        fullWidth
        variant={"outlined"}
        color={"inherit"}
      >
        Login with Google
      </ButtonPill>
      {error && <Alert severity="error">{error}</Alert>}
    </React.Fragment>
  );
};

export default GoogleInAppButton;
